module.exports = __webpack_public_path__ + "static/img/menage5.73885026.png";